import { array, boolean, literal, nullable, number, optional, string, type, union } from 'superstruct';
import { Sale } from '../typescript/sale';
export const FeaturedVariantImage = type({
    id: number(),
    position: number(),
    alt: nullable(string()),
    width: number(),
    height: number(),
    src: string(),
    variant_ids: array(number())
});
export const FeaturedVariantMedia = type({
    id: number()
});
export const Variant = type({
    id: number(),
    title: string(),
    option1: string(),
    option2: nullable(string()),
    option3: nullable(string()),
    options: array(string()),
    sku: nullable(string()),
    requires_shipping: boolean(),
    taxable: boolean(),
    available: boolean(),
    name: string(),
    public_title: nullable(string()),
    price: number(),
    compare_at_price: nullable(number()),
    weight: number(),
    barcode: nullable(string()),
    featured_image: nullable(FeaturedVariantImage),
    featured_media: optional(nullable(FeaturedVariantMedia))
});
export const Media = type({
    id: number(),
    position: number(),
    media_type: string()
});
export const Product = type({
    id: number(),
    title: string(),
    handle: string(),
    description: string(),
    published_at: nullable(string()),
    created_at: string(),
    vendor: string(),
    featured_image: nullable(string()),
    type: string(),
    tags: array(string()),
    price: number(),
    price_min: number(),
    price_max: number(),
    available: boolean(),
    price_varies: boolean(),
    compare_at_price: nullable(number()),
    compare_at_price_min: nullable(number()),
    compare_at_price_max: nullable(number()),
    compare_at_price_varies: boolean(),
    variants: array(Variant),
    images: array(string()),
    options: array(string()),
    media: optional(array(Media)),
    content: string()
});
export const OptionWithValues = type({
    name: string(),
    values: array(string())
});
export const OptionsWithValues = array(OptionWithValues);
export const Settings = type({
    renderStyle: union([
        literal('dropdowns'),
        literal('radios')
    ])
});
export const SelectedVariantId = number();
export const ProductTags = array(string());
export const ProductOptionsIO = type({
    product: Product,
    optionsWithValues: OptionsWithValues,
    selectedVariantId: SelectedVariantId,
    settings: Settings,
    productTags: ProductTags,
    sale: Sale,
    hasProductEmbroidering: boolean(),
    embroideringPrice: nullable(string()),
    embroideryDisclaimer: nullable(string()),
    customerId: nullable(number())
});
